
import React from 'react'
import Page from '../components/Page'

export default class extends React.Component {
  render() {
    return (
      <Page title="Runeword preparation" padding>
        <h3>Remove items from sockets</h3>
        <p>
          1 Hel Rune + Scroll of Town Portal + Any Socketed Item
        </p>
        <ul>
          <li>Removes the jewels, gems, or runes from the sockets in an item.</li>
          <li>The items in the sockets are destroyed, and all bonuses granted by those items are removed</li>
        </ul>
        
        <h3>Increase item quality</h3>
        <p>1 Eld Rune + 1 Chipped Gem + Low Quality Weapon --> Normal Quality Weapon of same type</p>
        <p>1 El Rune + 1 Chipped Gem + Low Quality Armor --> Normal Quality Armor of same type</p>

        <h3>Add sockets to items</h3>
        <p>1 Tal Rune + 1 Thul Rune + 1 Perfect Topaz + Normal Body Armor --> Socketed Body Armor of same type</p>
        <p>1 Ral Rune + 1 Amn Rune + 1 Perfect Amethyst + Normal Weapon = Socketed Weapon of same type</p>
        <p>1 Ral Rune + 1 Thul Rune + 1 Perfect Sapphire + Normal Helm --> Socketed Helm of same type</p>
        <p>1 Tal Rune + 1 Amn Rune + 1 Perfect Ruby + Normal Shield --> Socketed Shield of same type</p>
        <p>3 Perfect Skulls + 1 Rare Item + Stone of Jordan --> Add 1 Socket To a Rare Item</p>
      </Page>
    )
  }
}